import { render, staticRenderFns } from "./QuickKeys.vue?vue&type=template&id=78919999&scoped=true"
import script from "./QuickKeys.vue?vue&type=script&lang=js"
export * from "./QuickKeys.vue?vue&type=script&lang=js"
import style0 from "./QuickKeys.vue?vue&type=style&index=0&id=78919999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78919999",
  null
  
)

export default component.exports